'use client';

import { useEffect } from 'react';

import { useEventBatchContext } from './useEventBatch';

export const useObserver = (element: HTMLElement | null, data: any, identifier: string) => {
  const { sendEvent } = useEventBatchContext();

  useEffect(() => {
    observerElement(element, data, sendEvent, identifier);
  }, [element]);
};

export const observerElement = (
  element: HTMLElement | null,
  data: any,
  sendEvent: (event: any, identifier: string) => void,
  identifier: string
) => {
  if (!element) return;
  const options = {
    threshold: 1.0
  };
  const observer = new IntersectionObserver((entry, observer) => {
    if (!entry[0].isIntersecting) return;
    sendEvent(data, identifier);

    observer.disconnect();
  }, options);
  observer.observe(element);
};
